import type { CollectionDetailResponse } from '@aeris/contracts'
import { parseAmount } from '@aeris/finance'
import type { StatementEntry } from '@aeris/printing'

/**
 * Os títulos do extrato, com o que o cliente levou em cada nota (F237).
 *
 * O gerente da Elite: "o cliente foi pagar três notas… tive que puxar nota
 * por nota em Vendas e tirar print pra mandar pra ele". Os itens vão no
 * PRIMEIRO título de cada nota: as parcelas 2/3 e 3/3 são da mesma venda, e
 * repetir a lista em cada uma faria o cliente achar que comprou três vezes.
 */

/** `2.000000` → `2`, `1.500000` → `1,5`: o que se lê no papel. */
const quantity = (wire: string): string =>
  wire.replace(/\.?0+$/, '').replace('.', ',')

export const statementEntriesOf = (
  data: Pick<CollectionDetailResponse, 'entries' | 'documents'>
): StatementEntry[] => {
  const documents = new Map(
    data.documents.map((document) => [document.id, document])
  )
  const listed = new Set<string>()

  return data.entries.map((entry) => {
    const base = {
      dueAt: new Date(entry.dueAt),
      description: entry.description,
      daysOverdue: entry.daysOverdue,
      outstanding: parseAmount(entry.outstanding),
    }
    const document =
      entry.salesDocumentId === null
        ? undefined
        : documents.get(entry.salesDocumentId)
    if (document === undefined || listed.has(document.id)) return base

    listed.add(document.id)
    return {
      ...base,
      items: document.lines.map((line) => ({
        description: line.description,
        quantity: quantity(line.quantity),
        total: parseAmount(line.total),
      })),
    }
  })
}
